<div
  class="preview-page-item-container"
  [ngClass]="{ 'preview-page-item-container-selected': isSelected }"
  [ngStyle]="containerStyle"
  (click)="toggleSelection.emit()"
>
  <div class="preview-page-item-image-container">
    <img [src]="imageUrl" [alt]="pageNumber" class="preview-page-item-image" />
  </div>
  <div class="page-number-box">
    <p class="page-number-box-text">{{ pageNumber }}</p>
  </div>
  <div *ngIf="isSelected" class="selected-box-container">
    <app-pencil-icon
      class="selected-box-icon"
      [name]="'check_box'"
      [type]="IconTypes.materialIcon"
    ></app-pencil-icon>
  </div>
</div>
